// removed by extract-text-webpack-plugin
module.exports = {"link":"src-components-Bookmarklet----styles-module---link---1u2lh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Bookmarklet/styles.module.css
// module id = 120
// module chunks = 35783957827783 114276838955818